import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useContext } from 'react';
import classNames from 'classnames/bind';
import { useI18n } from 'next-localization';
import Link from 'components/helpers/Link/Link';
import { GetLinkFieldIcon } from 'models/fields';
import { contextType, HeaderContext, UtilitySection, UtilityLinkItem, FlyOut } from './Header';

import styles from './Header.module.scss';
import UtilityNavFlyOut from './UtilityNavFlyOut';

const cx = classNames.bind(styles);

type SecondaryNavProps = {
  utilitySection: UtilitySection;
  children?: React.ReactNode;
};

const SecondaryNav = (props: SecondaryNavProps): React.JSX.Element | null => {
  const { isMobile, currentLang, currentPage, resetMobileMenu } = useContext(HeaderContext) as contextType;
  const { t } = useI18n();
  const { sitecoreContext } = useSitecoreContext();

  if (!props.utilitySection) {
    return <>{props.children}</>;
  }

  return (
    <>
      <nav aria-hidden={isMobile} aria-label={t('Aria-Label-Utility')} className={cx('header__secondary-nav')}>
        <ul>
          {props.utilitySection.utilityLinks.map((utility, i) => {
            if ((utility as UtilityLinkItem)?.link) {
              const utilityLinkItem: UtilityLinkItem = utility as UtilityLinkItem;
              if (utilityLinkItem.link?.value?.href != '' && utilityLinkItem.linkText?.value != '') {
                return (
                  <li key={i}>
                    <Link
                      field={utilityLinkItem.link}
                      lang={utilityLinkItem.datasourceLanguage || currentLang}
                      icon={GetLinkFieldIcon(utilityLinkItem.link)}
                      aria-current={utilityLinkItem.link.value.href == currentPage ? 'page' : undefined}
                      showLinkTextWithChildrenPresent={false}
                      onClick={() => {
                        resetMobileMenu();
                      }}
                    >
                      <Text field={utilityLinkItem.linkText} encode={sitecoreContext.pageEditing} />
                    </Link>
                  </li>
                );
              } else {
                return null;
              }
            } else {
              const utilityFlyOut: FlyOut = utility as FlyOut;
              return (
                <li key={i}>
                  <UtilityNavFlyOut
                    index={0}
                    userTypeDropdownLabel={utilityFlyOut.userTypeDropdownLabel}
                    customerTypes={utilityFlyOut.customerTypes}
                    usernameLabel={utilityFlyOut.usernameLabel}
                    buttonText={utilityFlyOut.buttonText}
                    errorTextForDropdown={utilityFlyOut.errorTextForDropdown}
                    errorTextForUsername={utilityFlyOut.errorTextForUsername}
                    mobileDestination={utilityFlyOut.mobileDestination}
                    mobileDestinationLabel={utilityFlyOut.mobileDestinationLabel}
                  />
                </li>
              );
            }
          })}
        </ul>
      </nav>
      {props.children}
    </>
  );
};

export default SecondaryNav;
